export const createBusinessListStyles = {
  wrapper: { display: "flex", justifyContent: "center" },
  mainContainer: {
    width: "100%",
    maxWidth: {
      xs: "90vw",
      sm: "70vw",
      md: "40vw",
    },
  },

  // search
  searchContainer: {
    width: { xs: "100%", sm: "400px" },
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    mt: 1,
    mb: 2,
  },
  searchInput: {
    maxWidth: "400px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    "& .MuiOutlinedInput-root": {
      padding: "5px 8px",
      fontSize: "15px",
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #ccc",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "5px 0",
    },
  },

  addBtn: {
    paddingY: "5px",
    width: { xs: "100%", sm: "fit-content" },
    // position: "absolute",
    // right: 0,
    // top: 0,
    // display: {
    //   xs: "none",
    //   sm: "block",
    // },
  },

  selectedBusinessContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    marginY: 1,
  },

  inputLabel: {
    fontSize: "17px",
    fontWeight: "600",
    color: "#000",
  },

  btnContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    marginTop: 1,
  },
  actionBtn: {
    width: "100%",
    marginTop: "20px",
    paddingY: "10px",
  },

  //   business list card:
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    marginBottom: "16px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  },

  imageContainer: {
    position: "relative",
  },
  image: {
    width: "100%",
    height: "120px",
    shadowRadius: "8px",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  favoriteIcon: {
    position: "absolute",
    top: 10,
    right: 10,
    cursor: "pointer",
  },
  contentContainer: {
    paddingX: "15px",
    paddingY: "10px",
    minHeight: "130px",
  },
  title: {
    fontSize: "17px",
    color: "#0D0D0D",
    fontWeight: "600",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  address: {
    fontSize: "13px",
    color: "#595959",
    fontWeight: "400",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  description: {
    fontSize: "15px",
    color: "#0D0D0D",
    fontWeight: "400",
    marginTop: "5px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
  },
};
